export default __webpack_public_path__ + "static/selectMedia-75c616da610d8c6fd25d033592ff91f0.svg";